import { useMutation, useQueryClient } from '@tanstack/react-query';
import { converters as filesConverters } from 'store/files';
import { loaders } from './feedback.loaders';
import { feedbackKeys } from './feedback.queries';

export const useUpdateFeedbackItem = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateFeedbackItem, {
    onSuccess: () => {
      return queryClient.invalidateQueries(feedbackKeys.all);
    },
  });
};

export const useBulkUpdateFeedbackStatus = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.bulkUpdateFeedbackStatus, {
    onSuccess: () => {
      return queryClient.invalidateQueries(feedbackKeys.all);
    },
  });
};

export const useBulkDeleteFeedback = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.bulkDeleteFeedback, {
    onSuccess: () => {
      return queryClient.invalidateQueries(feedbackKeys.lists);
    },
  });
};

export const useExportXlsDiscountFeedbackItems = () => {
  return useMutation(loaders.exportXlsDiscountFeedbackItems, {
    onSuccess: filesConverters.export,
  });
};
